<template>
  <router-view v-if="routerAlive"/>
</template>

<script>
import { getLanguageCode } from '@/i18n'
import { mapActions, mapGetters } from 'vuex'
import { getFilePath } from '@/utils/qiniu'
import { deviceType } from '@/utils/common'
import { POST_APPLICANT_SCOPE } from '@/constant/questionnaire'

export default {
  metaInfo () {
    return {
      link: this.linkList,
      style: this.styleList
    }
  },
  data () {
    return {
      routerAlive: true,
      invitationInfo: {
        type: POST_APPLICANT_SCOPE,
        company: {
          id: '',
          name: ''
        }
      },
      invitationCode: null,
      isCandidate: true,
      userName: '',
      linkList: [],
      styleList: []
    }
  },
  computed: {
    invitationId () {
      return this.$route.params.invitationId
    },
    headerImage () {
      const isMobile = deviceType.isMobile
      let imagePath = null
      if (isMobile) {
        imagePath = this.invitationInfo.mobile_image
      } else {
        imagePath = this.invitationInfo.pc_image
      }
      return getFilePath(imagePath) || ''
    },
    logoPath () {
      return this.invitationInfo.logo
    },
    currentAccount () {
      return this.getCurrentAccount()
    }
  },
  beforeCreate () {
    this.$i18n.locale = getLanguageCode()
  },
  async created () {
    this.handleEventInBus()
    this.$eventBus.$emit('showLoading', true)
    this.showQuestionnairePage(false)
    try {
      this.refreshPageCss()
      await this.initData()
      // await this.checkPermission(this.invitationId)
    } finally {
      this.showQuestionnairePage(true)
      this.$eventBus.$emit('showLoading', false)
    }
  },
  methods: {
    ...mapActions('account', ['getSessionAccountInfo']),
    ...mapActions('questionnaire', ['checkQuestionnairePermission', 'checkQuestionnaireInvitationCode']),
    ...mapGetters('account', ['getCurrentAccount']),
    refreshPageCss () {
      if (this.$route.name === 'questionnaireSiteLayout') {
        this.linkList = []
      } else {
        this.linkList = [
          {
            rel: 'stylesheet',
            href: '/vue-static/bootstrap/bootstrap.min.css'
          },
          {
            rel: 'stylesheet',
            href: `${process.env.VUE_APP_BASE_URL}static/style/mobile_web/style_common.css`
          },
          {
            rel: 'stylesheet',
            href: `${process.env.VUE_APP_BASE_URL}static/style/mobile_web/style_zh.css`
          }
        ]
      }
    },
    async initData () {
      let invitationCode = this.$route.query.invitationCode
      if (this.invitationCode && this.invitationInfo) {
        return
      }
      if (invitationCode) {
        try {
          const resp = await this.checkQuestionnaireInvitationCode({ invitationCode })
          if (resp && resp.is_code_correct && resp.invitation) {
            this.invitationInfo = resp.invitation
          } else {
            this.$router.push('/error/link-expired')
          }
          this.invitationCode = invitationCode
        } catch (err) {
          invitationCode = null
        }
        this.isCandidate = this.invitationInfo?.is_candidate_apply_job
        this.userName = this.isCandidate ? this.invitationInfo.candidate?.name : this.invitationInfo.hiring_manager?.name
        this.$router.push({ path: this.getQuestionnaireHomePath(), query: this.$route.query })
      } else {
        this.invitationCode = null
      }
    },
    handleEventInBus () {
      this.$eventBus.$on('openQuestionnaireQuestionnairePage', (openWithNewWindow) => {
        const pagePath = `/recruiting/questionnaire/${this.invitationId}/questionnaire/${this.invitationInfo.questionnaire.id}?invitationCode=${this.invitationCode}`
        if (openWithNewWindow) {
          window.open(pagePath)
        } else {
          this.$router.push(pagePath)
        }
      })
    },
    setQuestionnaireThemeStyle (color) {
      this.styleList = [
        {
          vmid: 'custom-questionnaire-theme',
          innerHTML: `
            .custom-bg-color.main-background-style {
              background-color: ${color};
            }
            .custom-border-color.main-border-style {
              border-color: ${color};
            }
            .custom-color.dropdown-item:hover,
            .custom-color.day-cell-available:hover,
            .custom-color.selected-day-cell,
            .custom-color.main-color-style {
              color: ${color};
            }
          `
        }
      ]
    },
    getQuestionnaireHomePath () {
      let homePath = `/recruiting/questionnaire/${this.invitationId}`
      if (this.invitationInfo.microsite_url) {
        homePath += `/site/${this.invitationInfo.microsite_url}`
      } else {
        homePath += `/questionnaire/${this.invitationInfo.questionnaire.id}`
      }
      return homePath
    },
    showQuestionnairePage (isShow) {
      this.routerAlive = isShow
    },
    async checkPermission (invitationId) {
      if (this.$route.meta.noQuestionnairePermissionCheck) {
        return
      }
      this.$eventBus.$emit('showLoading', true)
      this.routerAlive = false
      try {
        const resp = await this.checkQuestionnairePermission(invitationId)
        if (resp) {
          this.routerAlive = true
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    async reloadMicroSite () {
      this.routerAlive = false
      await this.$nextTick()
      this.routerAlive = true
    }
  },
  watch: {
    $route (newVal) {
      this.checkPermission(this.invitationId)
      this.refreshPageCss()
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
